import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Badge, Button, cn } from "@workspace/frontend-ui";
import type { FC } from "react";
import type { SelectedProvider } from "../../types";

type Props = {
  provider: SelectedProvider;
  count: number;
  isActive: boolean;
  onToggleTab: (provider: SelectedProvider) => void;
  onRemove: (provider: SelectedProvider) => void;
};

const ProviderFilterChip: FC<Props> = ({
  provider,
  count,
  isActive,
  onToggleTab,
  onRemove,
}) => (
  <div
    className={cn(
      "inline-flex h-10 shrink-0 select-none items-center gap-1.5 whitespace-nowrap rounded-full border border-transparent pl-3 pr-2 text-sm font-medium",
      isActive
        ? "border-primary!"
        : "bg-secondary text-secondary-foreground hover:bg-secondary/80",
    )}
  >
    <Button
      variant="unstyled"
      className="rounded-tl-full! transition-none! p-0! size-6! rounded-full! bg-background!"
      onClick={() => onRemove(provider)}
    >
      <HugeiconsIcon
        icon={Cancel01Icon}
        size={16}
        className="text-foreground"
      />
    </Button>
    <Button
      variant="unstyled"
      className="h-auto! gap-1.5 p-0!"
      onClick={() => onToggleTab(provider)}
    >
      {provider.name}
      <Badge>{count}</Badge>
    </Button>
  </div>
);

export default ProviderFilterChip;
